import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import React from 'react'

import Breadcrumb from '../../Components/Breadcrumb'
import { useStyles } from './styles'

export default function DeleteAccount() {
  const classes = useStyles()

  const redirectLink = process.env.REACT_APP_DELETE_GOVBR

  return (
    <div>
      <Breadcrumb slug="Exclusão de conta" />
      <Box className={classes.containerTitle}>
        <Box className={classes.boxTitle}>
          <HighlightOffIcon className={classes.iconTitle} />
          <Box className={classes.containerTitles}>
            <Typography className={classes.title}>Exclusão de Conta</Typography>
            <Typography className={classes.subtitle}>
              Plataforma Salvador Digital
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className={classes.containerMain}>
        <h1>Como excluir sua conta na Plataforma Salvador Digital</h1>

        <h2>Pelo aplicativo Salvador Digital:</h2>
        <ol className={classes.list}>
          <li>
            Acesse <strong>Perfil</strong> no menu do app.
          </li>
          <li>
            Vá até <strong>Meus Dados</strong>.
          </li>
          <li>
            Selecione a opção <strong>&quot;Excluir Conta&quot;</strong> e
            confirme a exclusão.
          </li>
        </ol>

        <h2>Pelo Portal Salvador Digital:</h2>
        <ol className={classes.list}>
          <li>
            Acesse o menu <strong>Minha Conta</strong>.
          </li>
          <li>
            Entre na seção <strong>Meus Dados</strong>.
          </li>
          <li>
            Clique em <strong>&quot;Excluir Conta&quot;</strong> e confirme a
            exclusão.
          </li>
        </ol>

        <h3>O que acontece após a exclusão?</h3>
        <p>Sua conta na Plataforma Salvador Digital será removida.</p>
        <p>
          O seu perfil vinculado ao Salvador Digital será excluído, exceto
          aqueles exigidos por lei para retenção por um período adicional.
        </p>
        <p>
          Para voltar a utilizar a plataforma, será necessário realizar um novo
          login via gov.br, autorizar o acesso aos seus dados e aceitar
          novamente os termos de uso.
        </p>

        <h2>Como excluir sua conta gov.br</h2>
        <p>
          Se deseja excluir sua conta gov.br (e consequentemente revogar o
          acesso a todos os serviços vinculados, incluindo a Plataforma Salvador
          Digital), siga os passos abaixo:
        </p>
        <ol className={classes.list}>
          <li>
            Acesse o portal oficial do gov.br pelo link:{' '}
            <a href={redirectLink} target="_blank" rel="noreferrer">
              👉 Exclusão da conta gov.br
            </a>
          </li>
          <li>
            Siga as instruções apresentadas para solicitar a exclusão definitiva
            da sua conta gov.br.
          </li>
          <li>
            Após a exclusão da conta gov.br, seu acesso à Plataforma Salvador
            Digital será automaticamente revogado e todos os dados vinculados à
            autenticação serão removidos.
          </li>
        </ol>

        <h3>Atenção!</h3>
        <p>
          A exclusão da conta gov.br impactará o acesso a diversos serviços
          públicos digitais municipais, estaduais e federais que utilizam essa
          autenticação.
        </p>
        <p>
          Antes de excluir sua conta, recomendamos verificar se há serviços em
          andamento ou documentos importantes vinculados ao seu cadastro.
        </p>

        <p>
          Para mais informações, consulte a política de privacidade da
          Plataforma Salvador Digital:{' '}
          <a href="/politica-privacidade" target="_blank" rel="noreferrer">
            Política de Privacidade
          </a>
        </p>
      </Box>
    </div>
  )
}
